import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { COMMANDS } from '../../../mod-command/constants';
import { sendCommand } from '../../../mod-command/slice';
import { NOTIFICATION_TIMEOUT_TYPE, showNotification } from '../../../notifications';
import Dialog from '../../../base/ui/components/web/Dialog';
import { useTranslation } from 'react-i18next';
const UnMuteAllVideoDialog = ({ exclude, }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [title, setTitle] = useState(t("dialog.unMuteEveryoneElsesVideoTitle", { who: t("dialog.SIP") }));
    const [content, setContent] = useState(t("dialog.unMuteEveryonesVideoDialogSIP"));
    // Handles the submit action for enabling video for all participants.
    const onSubmit = () => {
        dispatch(sendCommand(COMMANDS.CAM_SIP.COMMAND, COMMANDS.CAM_SIP.ON));
        dispatch(showNotification({ titleKey: 'notify.unMutedVideoAllSIP' }, NOTIFICATION_TIMEOUT_TYPE.SHORT));
        return true;
    };
    return (React.createElement(Dialog, { ok: { translationKey: 'dialog.unMuteParticipantsVideoButton' }, onSubmit: onSubmit, title: title },
        React.createElement("div", { className: "mute-dialog" }, content)));
};
export default UnMuteAllVideoDialog;
